export const ANNOUNCE_IMAGE_MODAL_FIELDS_CONSTS = {
  autoCompleteTitleMsg: 'Автоматически подставляется заголовок новости',
  editHeaderAndAnnounceMsg: 'Редактировать заголовок и анонс для соц. сетей',
  ogDescriptionLabelMsg: 'Анонс для соц. сетей',
  ogTitleLabelMsg: 'Заголовок для соц. сетей'
}
